import React from 'react'

const DownloadIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.625 12.2751L10.625 3.75H9.375L9.375 12.2078L6.06924 8.9354L5.18069 9.8146L10.0492 14.6339L14.8237 9.81009L13.9262 8.93991L10.625 12.2751Z'
        fill='#141414'
      />
      <path d='M3.75 16.25L3.75 11.875H2.5V17.5L17.5 17.5V11.875H16.25V16.25L3.75 16.25Z' fill='#141414' />
    </svg>
  )
}

export default DownloadIcon
